<template>
    <al-icon
        icon="inverted-down"
        :class="arrowColorClass"
    />
</template>
<script setup lang="ts">
import { computed } from 'vue';
interface Props {
  colorClass?: string;
}

const props = withDefaults(defineProps<Props>(), { colorClass: '' });

const arrowColorClass = computed(() => {
    return props.colorClass;
});
</script>